import React from 'react';

export interface InboxSummaryProps {
  stats: { docs: number; emails: number; calls: number; events: number; tasks: number };
}

const InboxSummary: React.FC<InboxSummaryProps> = ({ stats }) => {
  return (
    <div className="eg-card px-4 py-3">
      <p className="text-sm eg-text-secondary">
        <span className="font-medium eg-text-primary">This week:</span>{' '}
        {stats.docs} docs{' '}
        <span className="eg-text-muted">&middot;</span>{' '}
        {stats.emails} emails{' '}
        <span className="eg-text-muted">&middot;</span>{' '}
        {stats.calls} calls{' '}
        <span className="eg-text-muted">&middot;</span>{' '}
        <span style={{ color: '#17c480' }}>
          {stats.events} events &middot; {stats.tasks} tasks created
        </span>
      </p>
    </div>
  );
};

export default InboxSummary;
